// @ts-nocheck
import { ChildFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";

export const LINK_MODAL_DEFAULT_VALUES = {
    showSwitchModal: false,
    modalHeadline: "Proceed to {0}",
    modalBody: "You'll be redirected to senco.com.",
    modalCtaLabel: "Continue",
    modalCancelLabel: "Stay here",
};

export const linkModalFields: ChildFieldDefinition[] = [
    {
        name: "showSwitchModal",
        displayName: "Show Switch Modal",
        editorTemplate: "CheckboxField",
        defaultValue: LINK_MODAL_DEFAULT_VALUES.showSwitchModal,
        tooltip: "Enable/disable the confirmation Modal when the user clicks a link that navigates to another site.",
    },
    {
        name: "modalHeadline",
        displayName: "Headline",
        editorTemplate: "TextField",
        defaultValue: LINK_MODAL_DEFAULT_VALUES.modalHeadline,
        tooltip:
            "Use {0} to automatically insert the clicked link's title. If you remove {0}, the text will be static.",
    },
    {
        name: "modalBody",
        displayName: "Message",
        editorTemplate: "MultilineTextField",
        defaultValue: LINK_MODAL_DEFAULT_VALUES.modalBody,
        tooltip: "{0} is automatically populated with the selected link title; delete {0} for a non-variable message.",
    },
    {
        name: "modalCtaLabel",
        displayName: "CTA Label",
        editorTemplate: "TextField",
        defaultValue: LINK_MODAL_DEFAULT_VALUES.modalCtaLabel,
        tooltip: "Primary action button label.",
    },
    {
        name: "modalCancelLabel",
        displayName: "Cancel Label",
        editorTemplate: "TextField",
        defaultValue: LINK_MODAL_DEFAULT_VALUES.modalCancelLabel,
        tooltip: "Cancel button label.",
    },
];
